export default __webpack_public_path__ + "static/media/ucsd-background.cbf188ee.jpg";